import { Action } from './action'
import { Actions } from './actions'

interface VonageStoreDetailsModel {
    globalsearch: boolean;
}
  
const initial: VonageStoreDetailsModel = {
    globalsearch: false,
};

export const vonageStore = (context: any) => {
    const { log } = context;
    return (state: VonageStoreDetailsModel = initial, action: Action<Actions>) => {
        let updated = state;
        const { type, payload } = action;
        switch (type) {
            case Actions.SETSTORE:
                updated = {
                    globalsearch: payload,
                };
                break;

            case Actions.RESETSTORE:
                updated = initial;
                break;
        }
        return updated;
    }
}
